import get from "lodash/get";
const flattenError = (error) => {
    // Errors based on an array of values will show at the index of the failing value...
    // so, first we'll filter the array to get rid of 'undefined' so we can grab the first
    // item that has an actual error.
    return Array.isArray(error)
        ? error.filter((item) => item !== undefined)[0]
        : error;
};
export function extractFormFieldError(name, errors) {
    var _a;
    var _b;
    const error = get(errors, name);
    const errorMessage = error
        ? ((_b = (_a = flattenError(error)) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "")
        : "";
    const hasError = Boolean(errorMessage);
    return {
        errorMessage,
        hasError,
    };
}
//# sourceMappingURL=forms.js.map